import { z } from "zod";

const CONSTRAINTS = {
  value: {
    minimum: 1,
    maximum: 5,
  },
};

const zRatingSchema = z
  .number()
  .int()
  .min(CONSTRAINTS.value.minimum)
  .max(CONSTRAINTS.value.maximum)
  .brand("Rating");
type RatingSchema = z.infer<typeof zRatingSchema>;

export { CONSTRAINTS, zRatingSchema };
export type { RatingSchema };
